import type { ComputedRef, InjectionKey } from "vue";
import { computed, hasInjectionContext, inject } from "vue";
import { useAuthStore } from "../AuthStore/useAuthStore";

export const DESCRIPTION_HINT_MODULE_KEY: InjectionKey<ComputedRef<boolean>> = Symbol("descriptionHintModule");

/**
 * Web gates description hints behind the staff-only `enableDescriptionHintModule` preference by providing
 * `useDescriptionHintModulePreference()` under `DESCRIPTION_HINT_MODULE_KEY`. Apps that do not provide it (CMS)
 * always show description hints.
 */
export function useDescriptionHintModuleEnabled(): ComputedRef<boolean> {
  if (!hasInjectionContext()) {
    return computed(() => true);
  }
  return inject(DESCRIPTION_HINT_MODULE_KEY, () => computed(() => true), true);
}

/**
 * The staff-only `enableDescriptionHintModule` preference at the selected location, off unless Verbleif staff switched
 * it on for the organisation or location. Without it the API offers no hints and refuses to manage them, so the
 * settings page and its menu entry are hidden as well.
 */
export function useDescriptionHintModulePreference(): ComputedRef<boolean> {
  const { userPreferences } = useAuthStore();
  return computed(() => userPreferences.value?.enableDescriptionHintModule === true);
}
